module.exports = __webpack_public_path__ + "img/facebook.74b0d9df.svg";